<template>
    <div style="margin-left: 30px;margin-top: -20px;">
        <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" mode="horizontal" @select="handleOpen">
            <el-menu-item index="1">
                <span>基本设置</span>
            </el-menu-item>
            <el-menu-item index="2" router="true">
                <span slot="title">账号设置</span>
            </el-menu-item>
            <el-menu-item index="3">
                <span>修改记录</span>
            </el-menu-item>
            <el-tooltip class="item" effect="light" placement="left" :value="true">
                <div slot="content" style="color: #F56C6C;font-size: 14px"><b><i class="el-icon-message-solid"></i> 修改配置后请点击此处保存</b> </div>
                <el-button style="text-align: center;float: right;margin-top: 26px" size="small" type=primary @click="submit">确定</el-button>
            </el-tooltip>
        </el-menu>
        <div v-show="activeIndex==1">
            <product-head :params="params" @changeHead="changeHead"></product-head>
            <limit-configure ref="limit-configure" :params="form.limit_configure"
                             @handleData="handleData" @getMemo="getMemo"></limit-configure>
            <div slot="footer" class="dialog-footer" style="text-align: center">
            </div>
        </div>
        <div v-show="activeIndex==2">
            <account-settings :customer_id="$route.query['id']" :product_id="form.product_id" ></account-settings>
        </div>
        <div v-if="activeIndex==3">
            <Recorder :customer_id="$route.query['id']" :product_id="form.product_id" :product_list="params.product_list"></Recorder>
        </div>
    </div>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>
<script>
    import LimitConfigure from "~/views/order/division/limitConfigure.vue";
    import CommonService from "~/services/common";
    import Config from "~/config/params";
    import RelationForm from "~/views/customer/relationForm.vue";
    import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
    import ProductHead from "~/views/order/partial/product_head.vue";
    import OrderService from "~/services/order";
    import AccountSettings from "~/views/order/division/AccountSettings.vue";
    import Recorder from "~/views/order/recoder/base.vue";

    export default {
        components: {
            LimitConfigure,
            RelationForm,
            RelationDialog,
            ProductHead,
            AccountSettings,
            Recorder
        },
        data() {
            return {
                is_submit: false,
                is_ajax_loading: false,
                validate_init: true,
                validate_limit_configure: false,
                form: {
                    order_id: '',
                    product_id: '',
                    init: {},
                    limit_configure: {},
                },
                showRelation: false,
                activeIndex: '1',
                formLabelWidth: '120px',
            };
        },
        props: {
            params: {
                required: true
            }
        },
        created() {

            this.form.limit_configure.product_code = this.params.product_code;
            this.form.product_id = this.params.product_id;
            this.form.order_id = this.params.order_id;
            this.form.type = this.params.open_state;
            this.form.end_at = this.params.end_at;
            this.form.start_at = this.params.start_at;
        },
        methods: {
            /**
             * 修改头部信息
             * @param data
             */
            changeHead(data) {
                this.form.type = data.type;
                this.form.end_at = data.end_at;
                this.form.start_at = data.start_at;
            },
            getMemo(data) {
                this.form.memo = data.memo
            },
            closeRelationDialog(show) {
                this.showRelation = show;
            },
            /**
             * 关联账号
             * */
            relationAccount(data) {
                this.$refs['relation-form'].getAlready();
            },
            /**
             * 表单提交
             * */
            submit() {
                if (this.is_submit) return false;
                this.is_submit = true;
                if (!this.validate_init) return false;
                OrderService.reviseProduct(this.form).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: res.msg == 'success' ? Config.REVISE_NOTICE : res.msg,
                            type: 'success'
                        });
                    }
                    this.is_submit = false;
                }).catch(err => {
                    this.is_submit = false;
                    console.error(err);
                });
            },
            /**@description 监听子组件数据 */
            handleData(data) {
                this.form.limit_configure = data
            },

            handleDataInit(data) {
                this.$refs['init-configure'].validateForm((rs) => {
                    this.validate_init = rs;
                })
                this.form.init = data;
            },
            handleDialogConfigureShow() {
                if (this.is_ajax_loading) return;
                if (!this.validate_init) {
                    this.$message({
                        message: '请进行初始化设置或者初始化设置有错误',
                        type: 'error'
                    })
                    return false;
                }
                ;
                if (!this.validate_limit_configure) {
                    this.$message({
                        message: '请进行额度设置或额度设置错误',
                        type: 'error'
                    })
                    return false;
                }
                this.$emit('handleDialogConfigureShow', this.form);
            },

            handleOpen(key, keyPath) {
                this.activeIndex = key;
            },
            handleDialogConfigureClose() {
                this.$emit('handleDialogConfigureShow', '', this.form.product_id);
            },
            /** 获取学校开通产品的信息 */
            getProductInfo() {
                CommonService.getSchoolProductInfo({
                    customer_id: global.customer_id,
                    product: this.params.code
                }).then(res => {
                    if (res.data) {
                        this.form.init.cor_domain = res.data.domain_url.split('.')[0];
                        this.form.init.cor_domain_url = res.data.domain_url;
                        this.form.init.cor_name = res.data.cor_name;
                        if (res.data.logo_url) {
                            this.form.init.fileList = [{name: '学校Logo展示图片', url: res.data.logo_url}];
                        }
                        this.validate_init = true;
                    }
                })
                if (this.$router.currentRoute.path == '/order/edit') {
                    this.validate_init = true;
                    this.validate_limit_configure = true;
                }
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/division/divisionConfigure.vue